module.exports = __webpack_public_path__ + "static/media/post-registration.f9190b99.jpg";